//React
import React from "react";
import {
  NavLink,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//Icon
import EmailIcon from '@material-ui/icons/Email';
import NoteIcon from '@material-ui/icons/Note';

class Comp extends React.Component {
  render() {
    return (
      <div className='sub_menu' style={{position:'relative', marginBottom:'20px'}}>
        <div className='outer'>
          <NavLink to="/mailbox/" exact className='link' activeClassName="selected">
            <EmailIcon className='icon'/>
            <div className='text'>メールボックス</div>
            {
              (this.props.notification.mailUnconfirmed > 0) &&
              <span style={{position:'absolute',top:'3px',left:'0px',right:'0px',margin:'auto',marginLeft:'28px',}}>
                <span className='badge'>{this.props.notification.mailUnconfirmed}</span>
              </span>
            }
          </NavLink>
          <NavLink to="/mailbox/draft/" className='link' activeClassName="selected">
            <NoteIcon className='icon' /><div className='text'>下書きメール</div>
          </NavLink>

        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    notification: state.notification,
	}
};
const mapDispatchToProps = dispatch => (
	bindActionCreators({
	}, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
